import React from 'react'
import { calcDaysToDate } from "@/common/time";
import { Machine } from "@/services/model/machine";
import { Translates } from '@/services/repository/i18n';

import './statuses.css'

export enum WarnLVL {
    Warn = 1,
    Error = 2
}

export interface MachineWarn {
    lvl: WarnLVL
    translateKey: string
}

export const MTHWarn: MachineWarn = {
    lvl: WarnLVL.Warn,
    translateKey: 'machine.warns.mth'
}

export const MTHError: MachineWarn = {
    lvl: WarnLVL.Error,
    translateKey: 'machine.warns.mth_error'
}

export const UDTWarn: MachineWarn = {
    lvl: WarnLVL.Warn,
    translateKey: 'machine.warns.udt'
}

export const UDTError: MachineWarn = {
    lvl: WarnLVL.Error,
    translateKey: 'machine.warns.udt_error'
}

export const InspectionWarn: MachineWarn = {
    lvl: WarnLVL.Warn,
    translateKey: 'machine.warns.inspection'
}

export const InspectionError: MachineWarn = {
    lvl: WarnLVL.Error,
    translateKey: 'machine.warns.inspection_error'
}

export const FailureError: MachineWarn = {
    lvl: WarnLVL.Error,
    translateKey: 'machine.warns.has_failure_error'
}

export const IMEIError: MachineWarn = {
    lvl: WarnLVL.Error,
    translateKey: 'machine.warns.imei'
}

export function calcStatuses(machine: Machine): MachineWarn[] {
    const warns: MachineWarn[] = []
    if (machine.inspectionExpirationDate) {
        const dayTo = calcDaysToDate(machine.inspectionExpirationDate)
        if (dayTo < 0) {
            warns.push(InspectionError)
        } else if (dayTo < 30) {
            warns.push(InspectionWarn)
        }
    }
    if (machine.udtExpirationDate) {
        const dayTo = calcDaysToDate(machine.udtExpirationDate)
        if (dayTo < 0) {
            warns.push(UDTError)
        } else if (dayTo < 30) {
            warns.push(UDTWarn)
        }
    }
    if (machine.mthExpiration && machine?.params?.deviceData?.engineHours) {
        const mthTo = machine.mthExpiration - machine?.params?.deviceData?.engineHours
        if (mthTo < 0) {
            warns.push(MTHError)
        } else if (mthTo < 30) {
            warns.push(MTHWarn)
        }
    }
    if (!machine.imei) {
        warns.push(IMEIError)
    }
    if (machine.statuses?.hasOpenFailure) {
        warns.push(FailureError)
    }
    return warns
}

export function MachineStatuses(translates: Translates, machine: Machine) {
    const warns = calcStatuses(machine)
    if (warns.length === 0) {
        return <div className="machine-statuses-wrap">
            <div className='ok'>
                <img src={`/public/img/icons/ok.svg`} />
                {translates.for('machine.status_ok')}
            </div>
        </div>
    }

    return <div className='machine-statuses-wrap'>
        <div className="machine-statuses">
            {warns.map((status) => status.lvl === WarnLVL.Error ? <div className='error'>
                <img src={`/public/img/icons/warn_red.svg`} />
                {translates.for(status.translateKey)}
            </div> : <div className='warn'>
                <img src={`/public/img/icons/warn_orange.svg`} />
                {translates.for(status.translateKey)}
            </div>)}
        </div>
    </div>
}